import { Component, Inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { MapService } from 'src/app/services/map.service';
import { ModuleService } from 'src/app/services/module.service';
import { SolarService } from 'src/app/services/cadastre-solaire/cadastre-solaire.service';

@UntilDestroy()
@Component({
    selector: 'cadastre-solaire-cta-mobile',
    templateUrl: './cadastre-solaire-cta-mobile.template.html',
    styleUrls: ['./cadastre-solaire-cta-mobile.component.scss'],
    standalone: false
})
export class CadastreSolaireCtaMobileComponent implements OnInit {
    public isShown: boolean = false;

    constructor(
        @Inject(MapService) private mapService: MapService,
        @Inject(ModuleService) private moduleService: ModuleService,
        @Inject(SolarService) private solarService: SolarService,
    ) {}

    ngOnInit(): void {
        this.mapService.map$.pipe(untilDestroyed(this)).subscribe((map) => {
            if (map) {
                this._initControl();
            }
        });

        this.solarService.mainStageObs$.pipe(untilDestroyed(this)).subscribe((mainStage) => {
            this.isShown = !!mainStage;
        });
    }

    private _initControl() {
        this.solarService.initCtaMobileControl();
        this.solarService.addCtaMobileControlToMap();
    }

    public toggleSolarModule() {
        this.moduleService.toggleModule('solar');
    }
}
